import HttpClienteToken from '../../services/HttpClientToken';

import { TipoPersonaProps } from '../../interfaces/catalogos/TipoPersonaInterface';

export const TipoPersona = () => {

    return new Promise<TipoPersonaProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/TipoPersona/', token)
            .then( ({ data } : { data : TipoPersonaProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ObtenerTipoPersona = () => {

    return new Promise<TipoPersonaProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/TipoPersona/ObtenerTipoPersona', token)
            .then( ({ data } : { data : TipoPersonaProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ActualizarTipoPersona = ( params: TipoPersonaProps ) => {

    return new Promise<TipoPersonaProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/TipoPersona/Actualizar', params, token)
            .then( ({ data } : { data : TipoPersonaProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idTipoPersona: 0,                 
                    descripcion: '',
                    activo: false,     
                });
            });
        }

    });

}

export const AgregarTipoPersona = ( params: TipoPersonaProps ) => {

    return new Promise<TipoPersonaProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/TipoPersona/Agregar', params, token)
            .then( ({ data } : { data : TipoPersonaProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idTipoPersona: 0,                   
                    descripcion: '',
                    activo: false,    
                });
            });
        }

    });

}